import React from "react";
import styled from "styled-components";

export default styled.div`
    font-size: 21px;
    line-height: 25px;
    text-decoration: underline;
    text-decoration-color: lightgrey;
    text-decoration-thickness: 1px;
    text-underline-offset: 1px;
    position: relative;
    margin-bottom: 5px;
    
    &.left-align {
        text-align: left;
        padding-left: 15px;
    }
`;